module.exports = __webpack_public_path__ + "media/images/front/pc/article/thum06-7cff47b051dc70a49999c7dc29a0f872.png";